
import { useEffect } from "react";
import Footer from "../components/footer/Footer";
import HomeComp1 from "../components/homecomponemts/HomeComp1";
import HomeComp2 from "../components/homecomponemts/HomeComp2";
import HomeComp3 from "../components/homecomponemts/HomeComp3";
import Navbar from "../components/navbar/Navbar";
import HomeSlider from "../components/slider/Slider";
import WhatsAppButton from "../components/WhatsappInt";

const Home=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
<div className="">
<Navbar/>

<HomeSlider/>

<HomeComp1/>

<HomeComp2/>
<HomeComp3/>

<Footer/>
</div>
    )
}
export default Home;